import {mapsApi, objectsApi} from "../../API/API";
import {
    SET_BLOB_LINK,
    SET_CATALOG_LIST,
    SET_CITIES_LIST,
    SET_CONTRACTS_DETAIL,
    SET_CONTRACTS_FIELDS_ITEM,
    UPDATE_BLOCKED_STATUS,
    SET_COMPANY_FIND_BY_INN
} from "./constans";
import {UpdateObjectsList} from "../Objects/actions";
import {clearObject} from "../../globalState/object/actions";
import {updateSavingStatus} from "../../globalState/app/actions";


export const setContractsDetail = (payload) => {
    return {
        type: SET_CONTRACTS_DETAIL,
        payload
    }
};


export const setContractsFieldsItem = (payload) => {
    return {
        type: SET_CONTRACTS_FIELDS_ITEM,
        payload
    }
};

export const setBlobLink = (payload) => {
    return {
        type: SET_BLOB_LINK,
        payload
    }
};

export const updateBlockedStatus = (newStatus) => {
    return {
        type: UPDATE_BLOCKED_STATUS,
        newStatus
    }
}


export const setCitiesList = (payload) => {
    return {
        type: SET_CITIES_LIST,
        payload
    }
}

export const setCatalogList = (payload) => {
    return {
        type: SET_CATALOG_LIST,
        payload
    }
}


export const setCompanyFindByINN = (payload) => {
    return {
        type: SET_COMPANY_FIND_BY_INN,
        payload
    }
}


export const getContractInfo = (formData) => async (dispatch) => {
    let response = await objectsApi.getContractInfo(formData);

    if (response) {
        dispatch(setContractsDetail(response.data))
    }

}


export const downloadContract = (formData) => async (dispatch) => {

    let response = await objectsApi.downloadContract(formData);
    if (response) {
        dispatch(setBlobLink(response))
    }
}


export const getCities = (country) => async (dispatch) => {
    let response = await mapsApi.getCities(country)

    if (response) {
        dispatch(setCitiesList(response.data))
    }
}

export const getCatalogList = (params) => async (dispatch) => {
    let response = await mapsApi.getCatalogList(params)

    if (response) {
        dispatch(setCatalogList(response.data))
    }
}

export const getEntityInfoByInn = (params) => async (dispatch) => {

    let response = await objectsApi.getEntityInfoByInn(params)

    if (response.status) {
        let data
        if (response.data.suggestions.length !== 0) {
            let company = response.data.suggestions[0].data

            data = {
                "COMPANY_NAME": company?.name['short_with_opf'],
                "LEGAL_ADDRESS": company?.address?.value,
                OGRN: company?.ogrn,
                KPP: company?.kpp,
            }
        } else {
            data = {
                "COMPANY_NAME": "",
                "LEGAL_ADDRESS": "",
                OGRN: "",
                KPP: "",
            }
        }


        dispatch(setCompanyFindByINN(data))

    }

    return true
}


export const getContractFieldsItem = (formData) => async (dispatch) => {
    let response = await objectsApi.getContractFields(formData);

    if (response) {
        let fields = {}
        let presets = {}
        let presetSelect = {}

        Object.keys(response.data).map(item => {
            fields = {...fields, [item]: response.data[item].fields}
            if (response.data[item].presets) {
                presets = {...presets, [item]: response.data[item].presets}
                Object.keys(response.data[item].presets).map(id => {
                    presetSelect = {
                        ...presetSelect,
                        [item]: {...presetSelect[item], [id]: response.data[item].presets[id]["presetName"]}
                    }
                })
            }
        })

        dispatch(setContractsFieldsItem({fieldsCollections: fields, presetsCollectios: presets, presetSelect}))
    }

}

export const setNextStage = (formData) => async (dispatch) => {
    dispatch(updateSavingStatus({status: "loading"}))
    let response = await objectsApi.setNextStage(formData)

    if (response.status) {
        dispatch(updateSavingStatus({status: "success"}))
        if (formData.stage === "enabled") {
            dispatch(clearObject())
        }

        return dispatch(UpdateObjectsList(response.data))
    } else {
        dispatch(updateSavingStatus({status: "error", message: response.data.message}))
    }

}